function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import PrimaForm from "../PrimaForm";
import { useQuery } from "@tanstack/react-query";
import { fetchPolizaEndorsements, getIndexQueryKey } from "../../actions/PolizaEndorsementActions";
import PolizaEndorsementForm from "../../PolizaEndorsementForm";

var ReenableForm = function ReenableForm(props) {
  var _polizaEndorsements$, _polizaEndorsements$2;

  var canModify = props.canModify,
      poliza = props.poliza,
      polizaEndorsement = props.polizaEndorsement,
      polizaEndorsementForm = props.polizaEndorsementForm,
      onChangeAmount = props.onChangeAmount,
      _props$editMode = props.editMode,
      editMode = _props$editMode === void 0 ? false : _props$editMode; // ### EDIT MODE ####

  if (editMode) return /*#__PURE__*/React.createElement(PrimaForm, {
    key: "ReenableForm",
    canModify: canModify,
    isDefaultOverrideActive: true,
    poliza: poliza,
    polizaEndorsement: polizaEndorsement,
    polizaEndorsementForm: polizaEndorsementForm,
    onChangeAmount: onChangeAmount
  }); // ### CREATE MODE ####

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isAlreadyCalculatedPrima = _React$useState2[0],
      setIsAlreadyCalculatedPrima = _React$useState2[1];

  var _useQuery = useQuery({
    queryKey: getIndexQueryKey(poliza.id),
    queryFn: function queryFn() {
      return fetchPolizaEndorsements(poliza.id);
    }
  }),
      data = _useQuery.data;

  var polizaEndorsements = data.poliza_endorsements;
  var existSomeEndorsement = polizaEndorsements && (polizaEndorsements === null || polizaEndorsements === void 0 ? void 0 : polizaEndorsements.length) > 0;
  var isCancellationActive = existSomeEndorsement && ((_polizaEndorsements$ = polizaEndorsements[0]) === null || _polizaEndorsements$ === void 0 ? void 0 : _polizaEndorsements$.aasm_state) === "approved" && ["cancellation", "annulment"].includes((_polizaEndorsements$2 = polizaEndorsements[0]) === null || _polizaEndorsements$2 === void 0 ? void 0 : _polizaEndorsements$2.endorsement_type);

  var calculatePrimaWithCancellation = function calculatePrimaWithCancellation() {
    var cancellation = polizaEndorsements[0];

    var newPolizaEndorsementForm = _objectSpread(_objectSpread({}, PolizaEndorsementForm), {}, {
      affects_net_bonus: cancellation.affects_net_bonus * -1,
      exempt_net_bonus: cancellation.exempt_net_bonus * -1
    });

    return newPolizaEndorsementForm;
  };

  React.useEffect(function () {
    if (!isAlreadyCalculatedPrima && isCancellationActive) {
      var newPolizaEndorsementForm = calculatePrimaWithCancellation();
      setIsAlreadyCalculatedPrima(true);
      onChangeAmount(newPolizaEndorsementForm);
    }
  }, [polizaEndorsementForm, isAlreadyCalculatedPrima]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isCancellationActive && /*#__PURE__*/React.createElement("h5", {
    style: {
      color: "red"
    }
  }, "Nota: No se puede calcular las primas automaticamente porque no existe una cancelacion/anulacion activa."), (isAlreadyCalculatedPrima || !isCancellationActive) && /*#__PURE__*/React.createElement(PrimaForm, {
    key: "ReenableForm",
    canModify: canModify,
    isDefaultOverrideActive: !isCancellationActive,
    poliza: poliza,
    polizaEndorsement: polizaEndorsement,
    polizaEndorsementForm: polizaEndorsementForm,
    onChangeAmount: onChangeAmount
  }));
};

export default ReenableForm;